export { default as painter } from './painter';
